import makeStyles from '@mui/styles/makeStyles';

export const useStylesECDS = makeStyles((theme) => ({
    mainRoot: {
        width: '100%',
        height: '95%',
    },
    root: {
        width: '100%',
    },
    container: {
        top: '20px',
        position: 'absolute',
        background: theme.palette.background.default,
        width: '70%',
        zIndex: 99,
        paddingLeft: '10px',
        paddingRight: '15px',
        marginLeft: '15%',
        marginTop: '1%',
        overflow: 'auto',
        maxHeight: '85%',
    },
    containerEcds: {
        top: '20px',
        position: 'absolute',
        background: theme.palette.background.default,
        width: '70%',
        zIndex: 99,
        paddingLeft: '10px',
        paddingRight: '15px',
        marginLeft: '15%',
        marginTop: '1%',
        height: '90%',
    },
    background: {
        position: 'absolute',
        background: 'black',
        top: 0,
        width: '100%',
        height: '100%',
        opacity: '0.5',
        zIndex: 99,
    },
    backgroundDialog: {
        backgroundColor: theme.palette.background.dialog,
    },
    dialogTitle: {
        textAlign: 'center',
        padding: '10px',
        fontSize: 'x-large',
    },
    dialogContent: {
        height: 'auto',
    },
    mainFooter: {
        height: 60,
        position: 'sticky',
        background: theme.palette.background.default,
        bottom: 0,
        marginBottom: '10px',
        zIndex: 99,
    },
    body: {
        maxHeight: '85%',
    },
    divider: {
        width: '100%',
        marginTop: 5,
        marginBottom: 15,
    },
    footer: {
        height: 50,
        marginTop: 10,
        position: 'relative',
        bottom: 0,
    },
    title: {
        textAlign: 'center',
    },
    input: {
        width: '100%',
        fontSize: '15px',
        marginBottom: 10,
        backgroundColor: theme.palette.background.paper,
        borderRadius: '6%',
    },
    button: {
        float: 'right',
        margin: 20,
        width: '120px',
        height: '30px',
    },
    buttonDialog: {
        background: '#fff',
        color: '#000',
        '&:hover': {
            background: '#fff',
        },
    },
    button2x: {
        float: 'right',
        margin: 20,
        width: '240px',
        height: '30px',
    },
    buttonLeft: {
        float: 'left',
        width: '120px',
        height: '30px',
        marginTop: 20,
        marginLeft: 20,
    },
    entryList: {
        margin: '15px',
        paddingBottom: '25px',
    },
    formControl: {
        width: '250px',
        padding: '10px',
        marginBottom: '30px',
    },
    paper: {
        borderRadius: '7px',
        background: theme.palette.background.paper,
        padding: '0 10px',
    },
    helperText: {
        fontSize: '10px',
    },
    header: {
        top: 0,
        height: 'auto',
        position: 'relative',
        borderRadius: '5px',
        margin: 10,
    },
    tableBody: {
        marginLeft: 10,
        marginRight: 10,
    },
    table: {
        width: 'auto',
        margin: '20px',
        padding: '10px',
    },
    headCell: {
        fontSize: 'small',
        background: theme.palette.background.default,
        "&.refresh": {
            fontSize: 14,
            background: theme.palette.background.paper,
            paddingLeft: 5,
            whiteSpace: 'pre',
        },
        '&:first-child': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
        },
        '&:last-child': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            paddingRight: 5,
        }
    },
    rowCell: {
        fontSize: 'small',
        '&.odd': {
            background: theme.palette.mode === 'dark' ? '#666666' : '#ccc',
        },
        "&.refresh": {
            fontSize: 'small',
            backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#313233',
        },
        '&:first-child': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            padding: 0,
            paddingLeft: 5,
        },
        '&:last-child': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
            paddingRight: 5,
        },
    },
    category: {
        margin: '10px',
        textAlign: 'center',
    },
    outcome: {
        borderRadius: '7px',
        border: '1px solid #7199E6',
        background: '#cfdffd',
        padding: 10,
        color: '#3F73D6',
        margin: '10px 0px',
    },
    description: {
        margin: '10px',
        textAlign: 'justify',
        fontStyle: 'italic',
        fontSize: 'small',
    },
    score: {
        fontSize: 'xxx-large',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    error: {
        color: '#f44336',
    },
    noData: {
        padding: 10,
        fontSize: 'xx-large',
        textAlign: 'center',
        fontWeight: 'bold',
    },
    loading: {
        padding: 10,
        textAlign: 'center',
        fontWeight: 'bold',
    },
    label: {
        color: theme.palette.mode === 'light' ? '#000' : '#FFF',
        fontWeight: 'bold',
        margin: '5px 0',
        '&.small': {
            fontSize: 'small',
        },
    },
    divRow: {
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
    },
    ecdsVersion: {
        fontSize: 'small',
        marginTop: 5,
        opacity: 0.5,
    },
}));
